/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class SISTwoPointSliderApi {
  async DeserializeProps(json : string) : Promise<sis.TwoPointSliderValue> {
    return await componentApi.call('sis', 'sis-two-point-slider', 'SISTwoPointSliderApi', 'DeserializeProps', {
      json,
    });
  }
}
export default new SISTwoPointSliderApi()
